import { font as foundationFont } from "../tokens/foundation";
import { font as semanticFont, color as semanticColor } from "../tokens/semantic";

const { family, weight, letterSpacing, lineHeight } = foundationFont;
const { desktop, mobile } = semanticFont;
const { text } = semanticColor;


export const typography = ({ theme }) => ({
    fontFamily: family.sans,
    fontFamilyMonospace: family.mono,
    fontWeightLight: weight.light,
    fontWeightRegular: weight.regular,
    fontWeightMedium: weight.medium,
    fontWeightSemiBold: weight.semiBold,
    fontWeightBold: weight.bold,
    h1: {
        fontFamily: family.sans,
        fontSize: desktop.heading.xxl,
        fontWeight: weight.semiBold,
        lineHeight: lineHeight.normal,
        letterSpacing: letterSpacing.condensed,
        color: text.heading,
        [theme.breakpoints.down('sm')]: {
            fontSize: mobile.heading.xxl,
        },
    },
    h2: {
        fontFamily: family.sans,
        fontSize: desktop.heading.xl,
        fontWeight: weight.semiBold,
        lineHeight: lineHeight.normal,
        letterSpacing: letterSpacing.condensed,
        color: text.heading,
        [theme.breakpoints.down('sm')]: {
            fontSize: mobile.heading.xl,
        },
    },
    h3: {
        fontFamily: family.sans,
        fontSize: desktop.heading.lg,
        fontWeight: weight.bold,
        lineHeight: lineHeight.normal,
        letterSpacing: letterSpacing.normal,
        color: text.heading,
        [theme.breakpoints.down('sm')]: {
            fontSize: mobile.heading.lg,
        },
    },
    h4: {
        fontFamily: family.sans,
        fontSize: desktop.heading.md,
        fontWeight: weight.medium,
        lineHeight: lineHeight.normal,
        letterSpacing: letterSpacing.normal,
        color: text.heading,
        [theme.breakpoints.down('sm')]: {
            fontSize: mobile.heading.md,
        },
    },
    h5: { // subtitle 1
        fontFamily: family.sans,
        fontSize: desktop.heading.sm,
        fontWeight: weight.medium,
        lineHeight: lineHeight.normal,
        letterSpacing: letterSpacing.normal,
        color: text.heading,
        [theme.breakpoints.down('sm')]: {
            fontSize: mobile.heading.sm,
        },
    },
    h6: { // subtitle 2
        fontFamily: family.sans,
        fontSize: desktop.heading.xs,
        fontWeight: weight.semiBold,
        lineHeight: lineHeight.normal,
        letterSpacing: letterSpacing.normal,
        color: text.heading,
        [theme.breakpoints.down('sm')]: {
            fontSize: mobile.heading.xs,
        },
    },
    body1: { // default body text
        fontFamily: family.sans,
        fontSize: desktop.body.md,
        fontWeight: weight.regular,
        color: text.body,
        lineHeight: lineHeight.normal,
        letterSpacing: letterSpacing.normal,
        [theme.breakpoints.down('sm')]: {
            fontSize: mobile.body.md,
        },
    },
    body2: { // small body text
        fontFamily: family.sans,
        fontSize: desktop.body.sm,
        fontWeight: weight.regular,
        color: text.body,
        lineHeight: lineHeight.relaxed,
        letterSpacing: letterSpacing.normal,
        [theme.breakpoints.down('sm')]: {
            fontSize: mobile.body.sm,
        },
    },
});

export default typography;